module.exports = __webpack_public_path__ + "static/align-product-card-evenly-95ab56b96e95e909963880020d5e8a0c.jpg";